import React from 'react';
import background from '../../assets/warming.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoOceanwarming extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        description="Ocean Warming"
        paragraph="Rising Ocean temperatures are leading to broad impacts on weather, infrastructure, and biodiversity."
        background={background}
     />
  
  );
 }
}   

export default InfoOceanwarming;